.group {
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
}

.legend {
  padding: 0;
  margin-bottom: 4px;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.segments {
  display: inline-flex;
  flex-wrap: wrap;
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  overflow: hidden;
}

.segment {
  position: relative;
  display: inline-flex;
}

.segment + .segment {
  border-left: 1px solid var(--tuna-border-default);
}

/* Visually hidden but focusable and announced: the label is the visible control */
.input {
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
  margin: 0;
}

.label {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding: 0 var(--tuna-spacing-2);
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-primary);
  cursor: pointer;
}

.input:checked + .label {
  background: var(--tuna-palette-primary-main);
  color: var(--tuna-palette-primary-contrastText);
}

.input:focus-visible + .label {
  outline: 2px solid var(--tuna-focus-ring);
  outline-offset: -3px;
}
